import { HeatmapDto } from "app/ApiClient";
import Point from "./Point";

export default class Heatmap {
  points!: Point[];

  width!: number;

  height!: number;

  minValue!: number;

  maxValue!: number;

  radius!: number;

  respondents!: number;

  maxOpacity!: number;

  minOpacity!: number;

  constructor(data?: HeatmapDto) {
    this.height = data?.height ?? 0;
    this.maxValue = data?.maxValue ?? 0;
    this.minValue = data?.minValue ?? 0;
    this.points = [...(data?.points ?? [])];
    this.radius = data?.radius ?? 0;
    this.respondents = data?.respondents ?? 0;
    this.width = data?.width ?? 0;
    this.maxOpacity = data?.maxOpacity ?? 0;
    this.minOpacity = data?.minOpacity ?? 0;
  }

  clone(): Heatmap {
    const clone = new Heatmap();

    clone.height = this.height;
    clone.width = this.width;
    clone.minValue = this.minValue;
    clone.maxValue = this.maxValue;
    clone.radius = this.radius;
    clone.respondents = this.respondents;
    clone.maxOpacity = this.maxOpacity;
    clone.minOpacity = this.minOpacity;

    clone.points = [...this.points];

    return clone;
  }
}
